module.exports = __webpack_public_path__ + "img/405.4ae1656c.jpg";